
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pages-sitemap.xml",
      function () {
        return require("private-next-pages/pages-sitemap.xml.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pages-sitemap.xml"])
      });
    }
  